import { get, post } from '@/api/core'

export namespace auth {
  /**
   * google 登录
   * redirect_uri 是预留参数
   */
  // export function loginOrSign() {
  //   return post('/auth/google/oauth2_link', {}, {})
  // }

  /** 登出 */
  export function logout() {
    return get('/auth/logout')
  }

  /** 企业员工绑定 */
  export function userBindCorp(p: {
    staffName: string
    location: string
    corpName?: string
    invitationCode?: string
    isFrom?: string
  }) {
    return post('/corp/staff_bind', {}, p)
  }

  export function userBindStatus() {
    return get<{ status: 'bound' | 'unbound' | 'apply_reject' | 'applying' }>(
      '/corp/staff_bind/status',
      {}
    )
  }

  /** 企业员工填invitation_code被拒绝，创建企业 */
  export function insertSessionAfterRejectBindRequest() {
    return post('/corp/create_new/after_reject', {}, {})
  }

  /** 临时用户信息获取 */
  export function tmpUserInfo() {
    return get<
      | {
          isAuth: true
          data: { name: string; avatar: string; email: string }
          isApplying: boolean
        }
      | {
          isAuth: false
          data: null
          isApplying: false
        }
    >('/auth/temp_staff/info')
  }

  /** 邮箱密码注册 */
  export function emailSignUp(p: { email: string; password: string }) {
    return post('/auth/email/sign_up', {}, p)
  }

  /** 邮箱验证码 */
  export function verifyEmailCode(verificationCode: string) {
    return post<{ hasBindCorp: boolean }>('/auth/email/code_verify', {}, { verificationCode })
  }

  /** 检查 email 是否被注册过 */
  export function checkEmailRegister(email: string) {
    return post<{ alreadyRegistered: boolean }>('/auth/check/email', {}, { email })
  }

  /** 邮箱登录 */
  export function emailLogin(p: { email: string; password: string }) {
    return post<{ isExpert: boolean }>('/auth/email/login_in', {}, p)
  }

  export function forgotPassword(p: { email: string }) {
    return post<{
      data: {
        errorMsg: string
        errorCode: number
        ttl: number
      }
    }>('/auth/email/forgot_password', {}, p)
  }

  export function submitResetPassword(p: { c: string; password: string }) {
    return post('/auth/email/forgot_password/reset', {}, p)
  }

  /** 获取员工信息 */
  export function me() {
    return get<{ data: null | Models.UserInfo }>('/staff/me', {})
  }
}
